import React from 'react';
import { CertificatePDFData } from './types';

interface AlertPreviewModalProps {
  certificate: CertificatePDFData;
  isOpen: boolean;
  onClose: () => void;
}

const AlertPreviewModal: React.FC<AlertPreviewModalProps> = ({ certificate, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '1rem'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '2rem',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ 
          fontSize: '3rem', 
          marginBottom: '1rem',
          color: '#1e40af'
        }}>
          📄
        </div>
        
        <h2 style={{ 
          color: '#1e40af', 
          marginBottom: '1rem',
          fontSize: '1.5rem'
        }}>
          Certificado #{certificate.id}
        </h2>
        
        <div style={{ 
          backgroundColor: '#f3f4f6', 
          padding: '1rem', 
          borderRadius: '6px',
          marginBottom: '1.5rem',
          textAlign: 'left'
        }}>
          <p style={{ margin: '0.5rem 0' }}>
            <strong>Cliente:</strong> {certificate.customer}
          </p>
          <p style={{ margin: '0.5rem 0' }}>
            <strong>Nº da Corrida:</strong> {certificate.heatNumber}
          </p>
          <p style={{ margin: '0.5rem 0' }}>
            <strong>Data:</strong> {certificate.date}
          </p>
          <p style={{ margin: '0.5rem 0' }}>
            <strong>Estruturas:</strong> {certificate.structures.length}
          </p>
          <p style={{ margin: '0.5rem 0' }}>
            <strong>Total de Parâmetros:</strong> {
              certificate.structures.reduce((acc, structure) => acc + structure.columns.length, 0)
            }
          </p>
          {certificate.images && certificate.images.length > 0 && (
            <p style={{ margin: '0.5rem 0' }}>
              <strong>Imagens:</strong> {certificate.images.length} página(s) adicional(is)
            </p>
          )}
        </div>
        
        <p style={{ 
          color: '#6b7280', 
          marginBottom: '1.5rem',
          fontSize: '0.875rem'
        }}>
          Para visualizar o PDF completo, use o botão Download PDF abaixo.
          {certificate.images && certificate.images.length > 0 && (
            <span> O PDF incluirá {certificate.images.length} página(s) adicional(is) com as imagens do certificado.</span>
          )}
        </p>
        
        <button
          onClick={onClose}
          style={{
            backgroundColor: '#1e40af',
            color: 'white',
            border: 'none',
            padding: '0.75rem 1.5rem',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: '500'
          }}
        >
          Fechar
        </button>
      </div>
    </div>
  );
};

export default AlertPreviewModal; 